/**
 * @description - Check the give number is a valid company number or not
 * @param {string} companyNo - Company number value to be validate
 */
export function isValidCompanyNo(companyNo: string): boolean {
	try {
		if (companyNo && companyNo.length == 9) {
			return true;
		} else {
			return false;
		}
	} catch (error) {
		return false;
	}
}
